import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static readonly targets = ['wrapper'];
  static readonly values = {
    email: String,
    emailPlaceholder: String,
    portal: String,
    portalSelector: String,
    healthData: String,
    healthDataSelector: String,
  };

  declare wrapperTarget: HTMLDivElement;
  declare hasWrapperTarget: boolean;
  declare emailValue: string;
  declare emailPlaceholderValue: string;
  declare portalValue: string;
  declare portalSelectorValue: string;
  declare healthDataValue: string;
  declare healthDataSelectorValue: string;

  private observer: MutationObserver | undefined = undefined;

  initialize(): void {
    this.observer = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          if (this.hasWrapperTarget) {
            this.updateEmail();
            this.updateLinks(this.portalSelectorValue, this.portalValue);
            this.updateLinks(
              this.healthDataSelectorValue,
              this.healthDataValue,
            );
          }

          if (this.observer) {
            this.observer.disconnect();
          }
        }
      }
    });
  }

  connect(): void {
    if (this.observer) {
      this.observer.observe(this.wrapperTarget, { childList: true });
    }
  }

  disconnect(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private updateEmail() {
    const linkElement = document.createElement('a');
    linkElement.setAttribute('href', `mailto:${this.emailValue}`);
    linkElement.setAttribute('target', '_blank');
    linkElement.innerHTML = this.emailValue;
    const regex = new RegExp(this.emailPlaceholderValue, 'g');
    this.wrapperTarget.innerHTML = this.wrapperTarget.innerHTML.replace(
      regex,
      linkElement.outerHTML,
    );
  }

  private updateLinks(selector: string, value: string) {
    if (selector?.length) {
      const links = this.wrapperTarget.querySelectorAll(selector);

      for (const link of links) {
        link.setAttribute('href', value);
        link.setAttribute('target', '_blank');
      }
    }
  }
}
